import React from 'react';
import {StyleProp, StyleSheet, TextStyle, ViewStyle} from 'react-native';
// https://github.com/iamacup/react-native-markdown-display/issues/158
// -> https://github.com/iamacup/react-native-markdown-display/issues/158#issuecomment-1453731664
//   -> https://www.npmjs.com/package/@ronradtke/react-native-markdown-display
import RNMarkdownDisplay, {
  MarkdownProps as RNMarkdownDisplayProps,
} from '@ronradtke/react-native-markdown-display';

import {openPageLink} from '../../utils/navigation';

import {textBodyStyles, textCaptionStyles, TextVariant} from './Text';

type MarkdownStyleOverrides = Record<string, StyleProp<TextStyle> | StyleProp<ViewStyle>>;

type MarkdownProps = RNMarkdownDisplayProps & {
  variant?: TextVariant;
  style?: MarkdownStyleOverrides;
};

const Markdown = ({
  children,
  variant = 'body',
  style = {},
  onLinkPress,
  ...rest
}: MarkdownProps) => {
  if (!children) return null;

  // Own-domain / relative hrefs -> in-app dispatch (openPageLink); foreign
  // domains -> browser. Returning false suppresses the markdown lib's default
  // Linking.openURL so the user is not bounced to the browser. Same contract
  // as DIS-1514; promoted to the shared default so every call site gets it.
  const handleLinkPress =
    onLinkPress ??
    ((url: string) => {
      openPageLink(url);
      return false;
    });

  const selectedStyles = variant === 'caption' ? captionStyles : bodyStyles;
  const styles = {...selectedStyles, ...style};

  return (
    <RNMarkdownDisplay {...rest} onLinkPress={handleLinkPress} style={styles}>
      {children}
    </RNMarkdownDisplay>
  );
};

const captionStyles = StyleSheet.create({
  body: textCaptionStyles,
  paragraph: {
    marginTop: 0,
    marginBottom: 0,
  },
});

const bodyStyles = StyleSheet.create({
  body: textBodyStyles,
});

export default Markdown;
